import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useBooking } from '../context/BookingContext';
import './CTA.css';

const CTA = () => {
  const { openCalendly } = useBooking();

  return (
    <section id="cta" className="cta section">
      <div className="container">
        <div className="cta-content">
          <p className="cta-label">Ready to Start?</p>
          <h2 className="cta-title">
            Find out what your business is<br />
            <span>leaving on the table.</span>
          </h2>
          <p className="cta-description">
            Book an assessment. We will show you where revenue is slipping and what it takes to fix it, with
            automation and AI built around how your team already works.
          </p>
          <div className="cta-actions">
            <button
              type="button"
              className="btn cta-primary"
              onClick={openCalendly}
            >
              Book an Assessment
              <ArrowRight size={17} />
            </button>
          </div>
          <p className="cta-note">
            General inquiries:{' '}
            <a href="mailto:contact@cure8studios.com" className="cta-email">
              contact@cure8studios.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
